import CTA from "./Components/sections/CTA";
import Features from "./Components/sections/Features";
import Footer from "./Components/sections/Footer";
import Hero from "./Components/sections/Hero";
import LinkToApp from "./Components/sections/LinkToApp";
import Mission from "./Components/sections/Mission";
import ViaEmailContact from "./Components/sections/ViaEmailContact";

function App() {
  return (
    <main className="">
      <Hero />
      <Features />
      <Mission />
      <CTA />
      <LinkToApp />
      <ViaEmailContact />
      <Footer />
    </main>
  );
}

export default App;
